export interface DetailsListConfig {
  items: DetailsListItem[];
}

export interface DetailsListItem {
  id: string;
  title: string;
  content: any;
  type: DetailsListItemType;
  styleClass?: string;
}

export enum DetailsListItemType {
  Text = 'text',
  Date = 'date',
  Decimal = 'decimal',
  Image = 'image',
}
